import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizationPipelineLabMeasurementEntryDto extends NamedDto {
    constructor() {
        super();

        /** @type {number} */
        this.labMeasurementReader = null;

        /** @type {number} */
        this.measurement = null;
    }

    /**
     * @typedef {Object} _OptimizationPipelineLabMeasurementEntryDtoProps
     * @property {number} labMeasurementReader
     * @property {number} measurement
     *
     * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationPipelineLabMeasurementEntryDtoProps} OptimizationPipelineLabMeasurementEntryDtoProps
     */

    /**
     *
     * @param {OptimizationPipelineLabMeasurementEntryDtoProps} props
     * @returns {OptimizationPipelineLabMeasurementEntryDto}
     */
    setup(props) {
        super.setup(props);

        this.labMeasurementReader = props.labMeasurementReader;
        this.measurement = props.measurement;

        return this;
    }
}

export default OptimizationPipelineLabMeasurementEntryDto;